import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BaseComponent } from "../../shared/components/base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { BuildingService } from "../../shared/service/building-service";
import { Building } from "../../shared/model/building";
import { ApplicationConfig } from "src/app/config/application.config";
import { ActionStatusType, JobDueDates, UrgencyType } from "../../shared/enums/enums";
import {JobListItem, JobService} from '../../shared/service/job.service';
import { HttpParams } from "@angular/common/http";
import { ActionSummary } from "../../shared/model/actionSummary";
import {ExecuteModalComponent} from '../../shared/components/execute-modal/execute-modal.component';
import {DeclineModalComponent} from '../../shared/components/decline-modal/decline-modal.component';

@Component({
    selector: "app-building",
    templateUrl: "./building.component.html",
    styleUrls: ["./building.component.scss"]
  })
export class BuildingComponent extends BaseComponent implements OnInit {

  @ViewChild(ExecuteModalComponent)
  executeModal: ExecuteModalComponent;
  @ViewChild(DeclineModalComponent)
  declineModal: DeclineModalComponent;

  private allJobs: ActionSummary[];
  public id: string;
  public building: Building;
  public filteredJobs: ActionSummary[];
  public detailsLoading: boolean;
  public jobsLoading: boolean;
  public selected = "all";
  public filterDates = [JobDueDates.TODAY, JobDueDates.TOMORROW, JobDueDates.THISWEEK, JobDueDates.NEXTWEEK] ;
  public selectedTab;
  public multiSelectOn: boolean = false;
  public jobsSelected: string[] = [];
  public isBeingPressed: boolean = false;
  constructor(
    private buildingService: BuildingService,
    private jobService: JobService,
    private route: ActivatedRoute,
    private router: Router,
    private config: ApplicationConfig,
  ) {
    super();
  }

  ngOnInit(): void {
      this.route.params.subscribe(params => {
        this.id = params['buildingId'];
        this.loadDetails();
        this.loadJobs();
      });

    }

    private loadDetails(){
      this.detailsLoading = true;
        this.buildingService.get(this.id).subscribe(building => {
            this.building = building;
            this.detailsLoading = false;
        });
    }

    private loadJobs () {
      this.jobsLoading = true;
      let params = new HttpParams();
      params = params.append('buildingGuids', this.id);
      params = params.append('statuses', ActionStatusType.ACCEPTED);
      params = params.append('statuses', ActionStatusType.EXECUTING);
      params = params.append('statuses', ActionStatusType.SENT);
      params = params.append('statuses', ActionStatusType.FINISHED);

      this.jobService.getJobs(params).subscribe(jobs => {
        this.allJobs = jobs;
        this.jobsLoading = false;
        this.onTabChange(this.getDefaultSelectedTab());
        this.selectedTab = this.getDefaultSelectedTab();
      });
    }

    private getAcceptedJobs() {
      return this.allJobs.filter(j => j.status == ActionStatusType.ACCEPTED || j.status == ActionStatusType.EXECUTING);
    }
    private getRequestedJobs() {
      return this.allJobs.filter(j => j.status == ActionStatusType.SENT);
    }
    private getFinishedJobs() {
      return this.allJobs.filter(j => j.status == ActionStatusType.FINISHED);
    }

    public isJobSelected(id: string): boolean{
      return this.jobsSelected.some(jobId => jobId == id);
    }

    public get hasMultipleJobsSelected(): boolean {
      return this.jobsSelected.length > 1;
    }

    public getDefaultSelectedTab(): number {
      return this.getAcceptedJobs().length > 0 ? 1 : this.getRequestedJobs().length > 0 ? 0 : this.getFinishedJobs().length > 0 ? 2 : 0;
    }

    public onTabChange(index: number) {
      if(this.multiSelectOn){
        this.multiSelectOn = !this.multiSelectOn;
        this.jobsSelected = [];
      }
      this.selectedTab = index;
      this.filteredJobs = index == 0 ? this.getRequestedJobs() : index == 1 ? this.getAcceptedJobs() : this.getFinishedJobs();
    }

  public getCover(): string {
    return this.building.coverUrl
      ? this.building.coverUrl
      : this.config.BUILDING_PLACEHOLDER_URL;
  }

  public getJobLocation(job: ActionSummary): string {
    if(job.issues && job.issues.length > 0) {
      let issue = job.issues[0];
      let location = '';
      if (issue.elementStructureLabel)
        location += `${issue.elementStructureLabel} / `;
      if (issue.issueLocationPath)
        location += `${issue.issueLocationPath}`;
      if (!location)
        location = issue.issueBuildingLabel;
      return location;
    }
    return null;
  }

  public doesBuildingHaveUrgentJobs(actions: ActionSummary[]): boolean {
    return actions.some(a => a.urgency == UrgencyType.URGENT); //TODO check for issue urgency aswell
  }

  public selectionChange(value: string){
    const acceptedJobs = this.getAcceptedJobs();
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    var first = today.getDate() - today.getDay();
    var last = first + 6;
    switch(value){
      case JobDueDates.TODAY:
        this.filteredJobs = acceptedJobs.filter(fj => new Date(new Date(fj.dueDate).setHours(0, 0, 0, 0)) === today);
        break;
      case JobDueDates.TOMORROW:
        const tomorrow = new Date(new Date().setDate(today.getDate() + 1));
        this.filteredJobs = acceptedJobs.filter(fj => new Date(new Date(fj.dueDate).setHours(0, 0, 0, 0)) === tomorrow);
        break;
      case JobDueDates.THISWEEK:
        const thisWeek = new Date(today.setDate(last));
        this.filteredJobs = acceptedJobs.filter(fj => new Date(new Date(fj.dueDate).setHours(0, 0, 0, 0)) === thisWeek);
        break;
      case JobDueDates.NEXTWEEK:
        const nextWeek = new Date(today.setDate(new Date(today.setDate(last)).getDate() + 7));
        this.filteredJobs = acceptedJobs.filter(fj => new Date(new Date(fj.dueDate).setHours(0, 0, 0, 0)) === nextWeek);
        break;
      default:
        this.filteredJobs = acceptedJobs;
        break;

    }
  }

  public onJobClicked(jobId: string){
    if(!this.multiSelectOn){
      this.router.navigate(['jobs/' + jobId], {relativeTo: this.route});
    }else{
      if(!this.isJobSelected(jobId)){
        this.jobsSelected.push(jobId);
      }else{
        const index = this.jobsSelected.indexOf(jobId, 0);
        if(index > -1){
          this.jobsSelected.splice(index, 1);
        }
      }
    }
  }

  public onPress(jobId: string){
    if(this.selectedTab <= 1){
      this.multiSelectOn = !this.multiSelectOn;
      if(!this.multiSelectOn){
        this.isBeingPressed = false;
        this.jobsSelected = [];
      }else{
        this.isBeingPressed = true;
        this.isBeingPressed ? this.jobsSelected.push(jobId) : null;
      }
    }

  }

  public onPressUp(){
    this.isBeingPressed = false;
  }


  public accept() {
    this.jobService.acceptAllJobs(this.jobsSelected).subscribe(() => {
      this.multiSelectOn = false;
      this.jobsSelected = [];
      location.reload();
    });
  }

  public decline() {
    this.jobService.declineAllJobs(this.jobsSelected).subscribe(() => {
      this.multiSelectOn = false;
      this.jobsSelected = [];
    });
  }

  public execute() {
    this.executeModal.show();
  }

  public declinePreviouslyAcceptedJobs() {
    this.declineModal.show();
  }
}
